/* eslint-disable no-console */
/* eslint-disable react/prop-types */

import React, { useContext, useEffect } from "react";
import { Link } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import ScreenHeight from "~components/ScreenHeight";
import { useKeyPress } from "~utils/hooks";
import Cross from "~components/svg/Cross";
import ContactForm from "~components/ContactForm";

const Nav = () => {
  const {
    aLaCarte,
    setALaCarte,
    bundles,
    setBundles,
    monogamyPlan,
    setMonogamyPlan,
    cartActive,
    setCartActive,
    mobileMenuOpen,
    setMobileMenuOpen,
    pathname
  } = useContext(AppContext);

  const { device } = useContext(DocumentContext);

  //

  const hasData = aLaCarte?.[0] || bundles?.[0] || monogamyPlan;

  const removeALaCarteItemByIndex = removeIndex => {
    if (!aLaCarte?.[0] || !aLaCarte?.[removeIndex]) {
      return;
    }

    const aLaCarteClone = JSON.parse(JSON.stringify(aLaCarte));

    aLaCarteClone.splice(removeIndex, 1);

    setALaCarte(aLaCarteClone);
  };

  const removeBundleItemByIndex = removeIndex => {
    if (!bundles?.[0] || !bundles?.[removeIndex]) {
      return;
    }

    const bundlesClone = JSON.parse(JSON.stringify(bundles));

    bundlesClone.splice(removeIndex, 1);

    setBundles(bundlesClone);
  };

  //

  const escKeyPressed = useKeyPress(`Escape`);

  useEffect(() => {
    setCartActive(false);
    setMobileMenuOpen(false);
  }, [escKeyPressed]);

  const links = [
    {
      title: `Home`,
      url: `/`
    },
    {
      title: `About`,
      url: `/about`
    },
    {
      title: `Process`,
      url: `/process`
    },
    {
      title: `Services`,
      url: `/services`
    },
    {
      title: `Work`,
      url: `/work`
    },
    {
      title: `Experiments`,
      url: `/experiments`
    }
  ];

  //

  return (
    <>
      {/* Contact Form */}
      <ScreenHeight
        className={`nav ${
          cartActive ? `cart-active` : `pointer-events-none`
        } w-screen fixed top-0 right-0 bottom-0 left-0 flex items-center justify-end z-50`}
      >
        {device !== `mobile` && (
          <div
            className="w-2/3 h-full"
            onClick={() => setCartActive(false)}
          ></div>
        )}
        <div className="nav__cart w-1/3 xs:w-full h-full relative z-20 flex flex-col items-stretch bg-gold text-white">
          <button
            type="button"
            className="nav__cart__close absolute"
            onClick={() => setCartActive(false)}
          >
            <Cross color="white" />
          </button>

          <header className="m-2 xs:mb-0">
            <h2 className="xs:mb-v1 universal-sans b1">Contact</h2>

            <h3 className="w-full xs:w-11/12 xs:mb-v2 universal-sans b2">
              {(hasData && (
                <span>
                  {/* eslint-disable-next-line */}
                  Email us at{" "}
                  <a href="mailto:blah@apostrophe.xyz">
                    blah@apostrophe.xyz
                  </a>{" "}
                  or fill out the form below.
                </span>
              )) || (
                <span className="animation-appear-down">
                  You haven’t selected anything yet.
                </span>
              )}
            </h3>
          </header>

          <div className="nav__cart__list w-full h-full relative pt-1 overflow-y-scroll border-t-white">
            {(hasData && (
              <ul className="universal-sans b1">
                {[...aLaCarte, ...bundles].map((item, itemIndex) => {
                  return (
                    <li
                      key={item}
                      className="nav__cart__item relative flex justify-between pt-v1 xs:pt-v4 pb-v1 xs:pb-v3 border-b-off-white--light"
                    >
                      <p className="b2 universal-sans">{item}</p>

                      <button
                        type="button"
                        className="relative flex items-center justify-center hover-underline"
                        onClick={() => {
                          if (itemIndex <= aLaCarte.length - 1) {
                            removeALaCarteItemByIndex(itemIndex);
                          } else {
                            removeBundleItemByIndex(
                              itemIndex - aLaCarte.length
                            );
                          }
                        }}
                      >
                        <span className="mr-v1 caption universal-sans uppercase">
                          REMOVE
                        </span>

                        <Cross color="white" className="h-8" />
                      </button>
                    </li>
                  );
                })}

                {monogamyPlan && (
                  <li className="nav__cart__item relative flex justify-between pt-v1 pb-v1 border-b-white">
                    <p className="b2 universal-sans">{monogamyPlan}</p>

                    <button
                      type="button"
                      className="relative flex items-center justify-center"
                      onClick={() => setMonogamyPlan(null)}
                    >
                      <span className="mr-v1 caption universal-sans uppercase">
                        REMOVE
                      </span>

                      <Cross color="white" />
                    </button>
                  </li>
                )}
              </ul>
            )) || (
              <>
                <p className="animation-appear-down animation-delay-1 mt-2 xs:mt-v2 universal-sans b2">
                  <span className="universal-sans b2">
                    {`If you know what services you are interested in then head to our ${
                      cartActive ? `` : ``
                    }`}
                  </span>
                  <Link
                    to="/services"
                    onClick={() => setCartActive(false)}
                    className="underline universal-sans b2"
                  >
                    services page
                  </Link>
                  <span className="universal-sans b2">
                    , take what you need and throw the rest away. Or get in
                    touch if you aren’t sure what you need.
                  </span>
                </p>
              </>
            )}
          </div>

          <div className="nav__cart__controls relative pt-v1 xs:pt-v3 border-t-white">
            <ContactForm />
          </div>
        </div>
      </ScreenHeight>

      {/* Mobile menu */}
      <ScreenHeight
        className={`touch-only nav ${
          mobileMenuOpen ? `menu-active` : ``
        } w-screen fixed top-0 right-0 bottom-0 left-0 flex items-center justify-end z-20 pointer-events-none`}
      >
        <div className="nav__menu w-full h-full absolute top-0 left-0 bottom-0 z-20 flex flex-col items-stretch pointer-events-auto bg-navy text-off-white">
          <ul className="w-full relative">
            <li className="w-full relative">
              {links.map((link, index) => {
                const linkKey = `${link.title}-link-${index}`;
                return (
                  <Link
                    key={linkKey}
                    to={link.url}
                    className="block mb-v8"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <h2
                      className={`f2 universal-sans ${pathname === link.url &&
                        `underline`}`}
                    >
                      {link.title}
                    </h2>
                  </Link>
                );
              })}
            </li>
          </ul>
        </div>
      </ScreenHeight>
    </>
  );
};

export default Nav;
